<ng-container *ngIf="diVisible">
  <div class="main-login-container">
    <!-- <div class="shape shape-01">
      <img src="./assets/images/auth-shape-01.svg" alt="" />
    </div>
    <div class="shape shape-02">
      <img src="./assets/images/auth-shape-02.svg" alt="" />
    </div> -->
    <div class="login-left-content d-none d-lg-flex">
      <div class="logo">
        <img src="./assets/images/logo-on-light.svg" alt="" />
      </div>
      <div class="auth-isometric">
        <img src="./assets/images/isometric-password.svg" class="img-fluid" alt="" />
      </div>
    </div>
    <div class="login-right-content">
      <div class="login-content">
        <div class="text-content has-back-button">
          <button mat-fab color="primary" (click)="logout()" class="shadow-none mb-4">
            <mat-icon> arrow_back </mat-icon>
          </button>

          <h1 class="title mb-2">
            {{ forgotPasswordConfig["title"] || constant["title"] }}
          </h1>
          <p>
            Enter your username, and we will send you the instructions on how to create a new password to your registered email
          </p>
        </div>
        <form [formGroup]="forgotPasswordForm">
          <div class="form-group">
            <mat-form-field appearance="outline">
              <mat-label>Username</mat-label>
              <input
                matInput
                type="text"
                formControlName="userName"
                [ngClass]="{
                  'is-invalid': submitted && formControl['userName']['errors']
                }"
              />
              <mat-hint  class="text-danger fw-bold" *ngIf="isInvalidUsername">Invalid Username</mat-hint>
            </mat-form-field>
            <mat-hint
              *ngIf="submitted && formControl['userName']['errors']"
              slot="start"
              class="error-message"
            >
              <ng-container
                *ngIf="formControl['userName']['errors']['required']"
                >{{
                  forgotPasswordConfig["validationMessages"]["userName"] ||
                    constant["validationMessages"]["userName"]
                }}</ng-container
              >
            </mat-hint>
          </div>
          <div class="buttons d-grid">
            <button
              mat-raised-button
              color="primary"
              [disabled]="forgotPasswordForm.invalid"
              (click)="onsubmit()"
            >
              Submit
            </button>

            <!-- <button  mat-raised-button (click)="logout()">Back</button> -->
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-container>
